import type { IReportTable } from '../../common/Visualization/types';
import type { AnalyticDateFilter } from '~/presentation/ui';
import type { DataSeries } from '@shopify/polaris-viz';
import type { IRMetricKey } from '../../common/type';

import { buildSeriesMap, getAllDatesSorted, buildDataSeries, TIME_SERIES } from './chartData';
import { getPreviousColumnName } from '../../common';

export const getLineChartData = ({
  data,
  metricKey,
  dimensions,
  timeDimension,
  onlyHasTimeDimension,
  templateLabelById,
  dateFilter,
}: {
  data: IReportTable;
  metricKey: IRMetricKey;
  dimensions: string[];
  timeDimension?: string;
  onlyHasTimeDimension?: boolean;
  templateLabelById: Record<string, string>;
  dateFilter: {
    currentDates: AnalyticDateFilter;
    previousDates: AnalyticDateFilter;
  };
}): { seriesData: DataSeries[]; seriesKey: Set<string>; hasCompareData: boolean } => {
  if (!timeDimension) {
    return { seriesData: [], seriesKey: new Set(), hasCompareData: false };
  }

  const firstDimensionKey = dimensions[0];
  const secondDimensionKey = dimensions[1];
  let seriesDimensionKey: string;

  if (onlyHasTimeDimension) {
    seriesDimensionKey = TIME_SERIES;
  } else if (firstDimensionKey === timeDimension) {
    seriesDimensionKey = secondDimensionKey;
  } else {
    seriesDimensionKey = firstDimensionKey;
  }

  const chartKeys = [timeDimension, seriesDimensionKey];
  const firstRow = data.rows?.[0];
  const hasCompareData = !!firstRow && getPreviousColumnName(timeDimension) in firstRow;

  const { seriesMap, keysSet, seriesKey } = buildSeriesMap({
    data,
    metricKey,
    chartKeys,
    templateLabelById,
  });

  const allKeys = getAllDatesSorted(keysSet, true);
  const seriesData = buildDataSeries({
    seriesMap,
    allKeys,
    showComparison: hasCompareData,
    dateFilter,
  });

  return {
    seriesData,
    seriesKey,
    hasCompareData,
  };
};
